import { Component, OnInit } from "@angular/core";
import { WebApiService, ApiError } from "../../../../_libs/web-api";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

@Component({
    selector: "dodo-error-notifier",
    templateUrl: "./error-notifier.component.html",
    styleUrls: ["./error-notifier.component.scss"],
    standalone: false
})
export class ErrorNotifierComponent implements OnInit {
	public error: ApiError;
	public errorDescription: string;
	public form: FormGroup;

	constructor(private webApiService: WebApiService, private fb: FormBuilder) {
		this.webApiService.webApiError.subscribe(error => {
			this.error = error;
			this.errorDescription =
				"There is an error on server side ... Please tell us your mobile no and we will try to get back to you soon";
			console.log(this.errorDescription);
		});

		this.buildForm();
	}

	ngOnInit() {}

	buildForm() {
		this.form = this.fb.group({
			name: ["", Validators.required],
			mobile: ["", Validators.required]
		});
	}
}
